import { Component, Input } from '@angular/core';

import { Agrupamento } from '../../pkw-data/collect/extrato/agrupamento.model';
import { Venda } from '../../pkw-data/collect/extrato/venda.model';
import { Empresa } from '../../pkw-data/core/empresa.model';

import { EstabelecimentoService } from '../../estabelecimentos/shared/estabelecimento.service';
import { Pagina, ListaPaginada } from '../../pkw-data/core/util/lista-paginada.model';
import { Operador } from '../../pkw-data/core/operador.model';
import { OperadorService } from '../../core/services/operador.service';
import { Estabelecimento } from '../../pkw-data/collect/estabelecimento/estabelecimento.model';
import { environment } from '../../../environments/environment';

import { Router } from '@angular/router';

@Component({
    selector: 'col-estabelecimentos-pendentes',
    templateUrl: './estabelecimentos-pendentes.component.html',
    styleUrls: ['./estabelecimentos-pendentes.component.scss']
})
export class EstabelecimentosPendentesComponent {
    @Input() agrupamento: Agrupamento<Venda>;
    @Input() empresas: Empresa[];

    empresaSelecionada: Empresa;

    estabelecimentos: ListaPaginada<Estabelecimento>;
    carregandoEstabelecimentos: boolean = true;
    contemEstabelecimentos: boolean = false;

    statusList: Array<any> = [
        { situacao: "Verificar dados de acesso", class: "fa-exclamation-circle icon-dados-acesso-color", tip: "Verificar dados de acesso", action: () => this.corrigirDadosDeAcesso() },
        { situacao: "Site exigindo ação do usuário", class: "fa-exclamation-circle icon-acao-usuario-color", tip: "Site exigindo ação do usuário", action: (operadora) => this.corrigirAcaoUsuario(operadora) },
        { situacao: "Bloqueio por múltipla autenticação", class: "fa-exclamation-circle icon-bloqueio-autenticacao-color", tip: "Bloqueio por múltipla autenticação", ajuda: environment.ajudaMFAGetNet, action: (operadora) => this.corrigirBloqueioMultiplaAutenticacao(operadora) }
    ];

    operador: Operador;

    tooltipPlacement: string = 'top';

    constructor(
        private estabelecimentoService: EstabelecimentoService,
        private operadorService: OperadorService,
        private router: Router
    ) {
        this.operadorService.corrente.subscribe(operador => {
            this.operador = operador
        });

        this.iniciarParametrosEstabelecimentos();
    }

    iniciarParametrosEstabelecimentos() {
        const pagina = new Pagina(1, 10);
        this.atualizarEstabelecimentos(pagina);
    }

    atualizarEstabelecimentos(pagina: Pagina, empresa? : Empresa) {
        let params = 'filter[situacao]=Bloqueio por múltipla autenticação&filter[situacao]=Site exigindo ação do usuário&filter[situacao]=Verificar dados de acesso&include=agente,agente.operadoraDeMaquina&fields[operadoras-de-maquina]=nome';

        if(empresa) {
            params = `${params}&filter[empresa][empresa][id]=${empresa.id}`
        }

        this.estabelecimentoService.pesquisarPorQuery(params, pagina).subscribe(resultado => {

            this.estabelecimentos = resultado;
            this.contemEstabelecimentos = resultado.length != 0;
            this.carregandoEstabelecimentos = false;
        });
    }

    paginar(indice: number, tamanho: number) {
        const pagina = new Pagina(indice, tamanho);
        this.atualizarEstabelecimentos(pagina);
    }

    collectPermissaoVisualizarEstabelecimento(): boolean {
        return this.operador.UsaCollect().Visualizar === true;
    }

    collectPermissaoEditarEstabelecimento(): boolean {
        return this.operador.UsaCollect().Editar === true;
    }

    adquirirTextoTooltipStatus(estabelecimento: Estabelecimento, usarStatusComoPadrao?: boolean): string {
        const status = estabelecimento.situacao;
        const statusObject = this.statusList.find(statusObj => {
            return statusObj.situacao === status;
        })

        let tooltipText = !!usarStatusComoPadrao ? statusObject.situacao : '';

        if (!!statusObject) {
            tooltipText = statusObject.tip;
        }

        return tooltipText;
    }

    adquirirIconeStatus(estabelecimento: Estabelecimento): string {
        const status = estabelecimento.situacao;
        const statusObject = this.statusList.find(statusObj => {
            return statusObj.situacao === status;
        })

        let tooltipText = '';

        if (!!statusObject) {
            tooltipText = statusObject.class;
        }

        return tooltipText;
    }

    alterarEmpresa(empresa: Empresa) {
        this.carregandoEstabelecimentos = true;
        const pagina = new Pagina(1, 10);
        this.atualizarEstabelecimentos(pagina, empresa);
    }

    corrigir(estabelecimento: Estabelecimento) {
        const status = estabelecimento.situacao;
        const statusObject = this.statusList.find(statusObj => {
            return statusObj.situacao === status;
        });
        
        if (!!statusObject) {
            let operadora = estabelecimento.agente.operadoraDeMaquina._nome;
            statusObject.action(operadora); 
        }
    }

    corrigirAcaoUsuario(operadora) {
        if(operadora == 'Redecard') {
            window.open("https://ajuda.alterdata.com.br/cbc/collect-mudancas-na-operadora-rede-que-impactam-no-collect", "_blank");
        } else {
            this.router.navigate(["/estabelecimentos"]);
        }        
    }

    corrigirDadosDeAcesso() {
        this.router.navigate(["/estabelecimentos"]);
    }

    corrigirBloqueioMultiplaAutenticacao(operadora: string) {
        switch(operadora) {
            case 'Santander Getnet':
                window.open(environment.santanderGetNetUrl, "_blank");
                break;
            default:
                this.router.navigate(["/estabelecimentos"]);
        }
    }

    saibaMais() {
        //TODO: Será implementado quando a documentação estiver pronta
    }
}


// WEBPACK FOOTER //
// ./src/app/extratos/estabelecimentos-pendentes/estabelecimentos-pendentes.component.ts